package com.eladfinish.bible.contest.ui.common

import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.ezrasil_sr
import com.eladfinish.bible.contest.kerenm
import com.eladfinish.bible.contest.keter_medium
import com.eladfinish.bible.contest.screens.settings.ui.screens.FONT_PREFERENCE_KEY
import com.eladfinish.bible.contest.stam_ashkenaz
import com.eladfinish.bible.contest.stam_sefarad
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.FontResource
import dev.icerock.moko.resources.compose.fontFamilyResource

@Composable
fun getCurrentFontFamily(settings: Settings): FontFamily {
    return fontFamilyResource(fontResource = getCurrentFontResource(settings))
}

fun getCurrentFontResource(settings: Settings): FontResource {
    return settings.getString(
        key = FONT_PREFERENCE_KEY,
        defaultValue = FONT_KETER_YG_MEDIUM,
    ).toFontResource()
}

const val FONT_KETER_YG_MEDIUM = "KeterYG-Medium.ttf"
const val FONT_EZRA_REGULAR = "Ezra-Regular.ttf"
const val FONT_KEREN_REGULAR = "Keren-Regular.ttf"
const val FONT_STAM_ASHKENAZ = "Stam-Ashkenaz.ttf"
const val FONT_STAM_SEFARAD = "Stam-Sefarad.ttf"

// גופנים של סת"ם לא תומכים בהצגת ניקוד וטעמי המקרא
val supportedFonts = listOf(
    FONT_KETER_YG_MEDIUM,
    FONT_EZRA_REGULAR,
    FONT_KEREN_REGULAR,
)

fun String.toFontResource(): FontResource {
    return when (this) {
        FONT_KETER_YG_MEDIUM -> SharedRes.fonts.keter_medium
        FONT_EZRA_REGULAR -> SharedRes.fonts.ezrasil_sr
        FONT_KEREN_REGULAR -> SharedRes.fonts.kerenm
        FONT_STAM_ASHKENAZ -> SharedRes.fonts.stam_ashkenaz
        FONT_STAM_SEFARAD -> SharedRes.fonts.stam_sefarad
        else -> SharedRes.fonts.keter_medium
    }
}
